import React, { useContext } from 'react';
import { OrderReviewContext, isFormHeaderHidden } from './OrderReviewContext';
import ListItemFormHeader from './ListItemFormHeader';

const COMMERCIAL_PRIMARY_FORM_HEADER_ID = 58;

function ListItemFormHeaders({ isCancelled, isHighConfidencePhotos }) {
  const { state } = useContext(OrderReviewContext);
  const { formHeaders } = state;

  // stepNumber must stay the real index into state.formHeaders, so skip hidden headers rather than filtering first
  let listItemFormHeaders =
    formHeaders &&
    formHeaders.map((formHeader, index) =>
      isFormHeaderHidden(formHeader, state) ? null : (
        <ListItemFormHeader key={formHeader.orderFormHeaderId} formHeader={formHeader} stepNumber={index} isHighConfidencePhotos={isHighConfidencePhotos} />
      ),
    );

  return listItemFormHeaders;
}

export default ListItemFormHeaders;
